interface PrivacyContent {
  header: string;
  body: string[];
  acknowledgement: string;
  acceptLabel: string;
}

export const privacyContent: Record<"de" | "fr" | "it", PrivacyContent> = {
  de: {
    header: "Datenschutzerklärung",
    body: [
      "Datenschutzerklärung zur wissenschaftlichen Online-Erhebung",
      "Universität Basel",
      "Forschungsprojekt: „Umgang im Konflikt – Kindeswohlgewährleistung durch alternative richterliche Verfahrenssteuerung in Umgangsszenarien“",
      "Leitung: Jonas Schütte, Universität Basel",
      "",
      "1. Verantwortliche Stelle",
      "Verantwortlich für die Datenbearbeitung:",
      "Jonas Schütte",
      "Doktorand, Juristische Fakultät, Universität Basel",
      "E-Mail: jonas.schuette@unibas.ch",
      "Adresse: Chalchrain 17, 6315 Oberägeri, Schweiz",
      "",
      "2. Zweck der Erhebung",
      "Die Erhebung dient der wissenschaftlichen Untersuchung richterlicher und behördlicher Verfahrenssteuerung im Kontext kindeswohlrelevanter Umgangskonflikte.",
      "Ziel ist es, empirische Erkenntnisse zu gewinnen, wie richterliche und behördliche Entscheidungsprozesse und Verfahrensgestaltung zur Kindeswohlgewährleistung beitragen können.",
      "Die Daten werden ausschliesslich zu wissenschaftlichen Forschungszwecken im Rahmen der Dissertation an der Universität Basel verarbeitet und nicht für kommerzielle Zwecke verwendet.",
      "",
      "3. Art der erhobenen Daten",
      "Im Rahmen dieser Online-Erhebung werden folgende Daten verarbeitet:",
      "- demografische Angaben (z. B. Alter, Berufsgruppe, Erfahrungsjahre),",
      "- berufsbezogene Einschätzungen und qualitative Angaben (Antworten auf offene und geschlossene Fragen),",
      "- technische Metadaten (z. B. Zeitpunkt der Teilnahme, Session-ID).",
      "Es werden personenbezogene Daten erhoben, jedoch keine besonders schützenswerten Personendaten im Sinne von Art. 5 lit. c DSG (wie z. B. Angaben zur Gesundheit, Religion, politischen Haltung oder Intimsphäre).",
      "",
      "4. Rechtsgrundlage der Datenbearbeitung",
      "Die Bearbeitung erfolgt auf Grundlage von:",
      "- Art. 31 Abs. 1 DSG (Einwilligung der betroffenen Person) sowie",
      "- Art. 31 Abs. 2 lit. e DSG (Bearbeitung zu wissenschaftlichen Zwecken)",
      "Die Teilnahme erfolgt freiwillig und basiert auf einer informierten Einwilligung der Teilnehmenden.",
      "",
      "5. Speicherung und Zugriff",
      "Die Daten werden auf Servern der Infomaniak Network SA, Schweiz, gespeichert.",
      "Die Server befinden sich in der Schweiz und unterliegen damit vollständig dem Schweizer Datenschutzrecht.",
      "Zugriff auf die Daten haben ausschliesslich:",
      "- der Projektleiter Jonas Schütte",
      "- und gegebenenfalls wissenschaftliche Betreuer:innen oder Auswertungsverantwortliche an der Universität Basel, sofern dies für die Auswertung erforderlich ist.",
      "Eine Weitergabe an Dritte oder Übermittlung ins Ausland erfolgt nicht.",
      "",
      "6. Aufbewahrungsdauer",
      "Die erhobenen Daten werden so lange gespeichert, wie es für die wissenschaftliche Auswertung, die Erstellung und allfällige Publikation der Dissertation erforderlich ist, längstens jedoch 10 Jahre nach Abschluss der Dissertation.",
      "Anschliessend werden die Daten anonymisiert oder gelöscht.",
      "",
      "7. Rechte der Teilnehmenden",
      "Teilnehmende haben das Recht:",
      "- auf Auskunft über die sie betreffenden Daten,",
      "- auf Berichtigung unrichtiger Angaben,",
      "- auf Löschung ihrer Daten (sofern keine wissenschaftlichen Gründe entgegenstehen),",
      "- auf Einschränkung der Bearbeitung,",
      "- sowie auf Widerruf der Einwilligung jederzeit und ohne Angabe von Gründen.",
      "Gesuche hierzu können an den oben genannten Verantwortlichen gerichtet werden.",
      "",
      "8. Freiwilligkeit und Anonymität",
      "Die Teilnahme an dieser Untersuchung ist freiwillig.",
      "Ein Abbruch der Befragung ist jederzeit ohne Nachteile möglich.",
      "Die erhobenen Daten werden vertraulich behandelt und ausschliesslich zu den beschriebenen Forschungszwecken verwendet.",
      "Eine Anonymisierung erfolgt nach Abschluss der Datenerhebung, sofern keine personenbezogene Zuordnung mehr erforderlich ist.",
      "",
      "9. Datensicherheit",
      "Die Datenübertragung erfolgt über eine verschlüsselte Verbindung (HTTPS).",
      "Die Speicherung und Verarbeitung erfolgen auf Servern in der Schweiz, die nach aktuellen Sicherheitsstandards geschützt sind.",
      "Zugriffsrechte sind auf das für die Forschung notwendige Minimum beschränkt.",
    ],
    acknowledgement:
      "Ich wurde über Zweck, Ablauf und Datenbearbeitung dieser wissenschaftlichen Untersuchung informiert. Ich nehme freiwillig teil und erkläre mich damit einverstanden, dass meine im Rahmen der Online-Erhebung angegebenen personenbezogenen Daten zu wissenschaftlichen Forschungszwecken verarbeitet werden.",
    acceptLabel: "Ich stimme der Datenschutzerklärung zu und möchte an der Erhebung teilnehmen.",
  },
  fr: {
    header: "Déclaration de confidentialité",
    body: [
      "Déclaration de confidentialité relative à l'enquête scientifique en ligne",
      "Université de Bâle",
      "Projet de recherche : « Relations parentales en cas de conflit – Garantie du bien-être de l'enfant grâce à une gestion judiciaire alternative des procédures dans les scénarios de relations parentales »",
      "Direction : Jonas Schütte, Université de Bâle",
      "",
      "1. Organisme responsable",
      "Responsable du traitement des données :",
      "Jonas Schütte",
      "Doctorant, Faculté de droit, Université de Bâle",
      "E-mail : jonas.schuette@unibas.ch",
      "Adresse : Chalchrain 17, 6315 Oberägeri, Suisse",
      "",
      "2. Objectif de l'enquête",
      "L'enquête sert à l'étude scientifique de la gestion judiciaire et administrative des procédures dans le contexte des conflits relatifs au droit de visite liés au bien-être de l'enfant.",
      "L'objectif est d'obtenir des résultats empiriques sur la manière dont les processus décisionnels judiciaires et administratifs et l'organisation des procédures peuvent contribuer à garantir le bien-être de l'enfant.",
      "Les données sont traitées exclusivement à des fins de recherche scientifique dans le cadre d'une thèse à l'université de Bâle et ne sont pas utilisées à des fins commerciales.",
      "",
      "3. Type de données collectées",
      "Dans le cadre de cette enquête en ligne, les données suivantes sont traitées :",
      "- données démographiques (par exemple, âge, catégorie professionnelle, années d'expérience),",
      "- évaluations professionnelles et données qualitatives (réponses à des questions ouvertes et fermées),",
      "- métadonnées techniques (par exemple, date de participation, identifiant de session).",
      "Des données à caractère personnel sont collectées, mais aucune donnée particulièrement sensible au sens de l'art. 5, let. c, LPD (telles que des informations sur la santé, la religion, les opinions politiques ou la vie privée).",
      "",
      "4. Base juridique du traitement des données",
      "Le traitement est effectué sur la base de :",
      "- l'art. 31, al. 1 LPD (consentement de la personne concernée) et",
      "- l'art. 31, al. 2, let. e LPD (traitement à des fins scientifiques)",
      "La participation est volontaire et repose sur le consentement éclairé des participants.",
      "",
      "5. Stockage et accès",
      "Les données sont stockées sur les serveurs d'Infomaniak Network SA, Suisse.",
      "Les serveurs sont situés en Suisse et sont donc entièrement soumis à la législation suisse sur la protection des données.",
      "Seules les personnes suivantes ont accès aux données :",
      "- le chef de projet Jonas Schütte",
      "- et, le cas échéant, les superviseurs scientifiques ou les responsables de l'évaluation à l'Université de Bâle, dans la mesure où cela est nécessaire pour l'évaluation.",
      "Les données ne sont pas transmises à des tiers ni transférées à l'étranger.",
      "",
      "6. Durée de conservation",
      "Les données collectées sont conservées aussi longtemps que nécessaire pour l'évaluation scientifique, la rédaction et la publication éventuelle de la thèse, mais au maximum 10 ans après la fin de la thèse.",
      "Les données sont ensuite anonymisées ou supprimées.",
      "",
      "7. Droits des participants",
      "Les participants ont le droit :",
      "- d'obtenir des informations sur les données les concernant,",
      "- de faire rectifier les informations erronées,",
      "- de faire supprimer leurs données (sauf si des raisons scientifiques s'y opposent),",
      "- de limiter le traitement,",
      "- ainsi que de révoquer leur consentement à tout moment et sans indication de motifs.",
      "Les demandes à cet effet peuvent être adressées au responsable susmentionné.",
      "",
      "8. Caractère volontaire et anonymat",
      "La participation à cette étude est volontaire.",
      "Il est possible d'interrompre l'enquête à tout moment sans inconvénient.",
      "Les données collectées sont traitées de manière confidentielle et utilisées exclusivement aux fins de recherche décrites.",
      "Une anonymisation est effectuée après la fin de la collecte des données, dans la mesure où aucune attribution à des personnes n'est plus nécessaire.",
      "",
      "9. Sécurité des données",
      "La transmission des données s'effectue via une connexion cryptée (HTTPS).",
      "Le stockage et le traitement sont effectués sur des serveurs situés en Suisse, qui sont protégés selon les normes de sécurité en vigueur.",
      "Les droits d'accès sont limités au minimum nécessaire pour la recherche.",
    ],
    acknowledgement:
      "J'ai été informé(e) de l'objectif, du déroulement et du traitement des données de cette étude scientifique. Je participe volontairement et j'accepte que les données personnelles que j'ai fournies dans le cadre de l'enquête en ligne soient traitées à des fins de recherche scientifique.",
    acceptLabel: "J'accepte la déclaration de confidentialité et souhaite participer à l'enquête.",
  },
  it: {
    header: "Informativa sulla privacy",
    body: [
      "Informativa sulla privacy relativa al sondaggio scientifico online",
      "Università di Basilea",
      "Progetto di ricerca: “Rapporti nel conflitto - Garanzia del benessere dei minori attraverso procedure giudiziarie alternative in scenari di rapporto”",
      "Direzione: Jonas Schütte, Università di Basilea",
      "",
      "1. Responsabile",
      "Responsabile del trattamento dei dati:",
      "Jonas Schütte",
      "Dottorando, Facoltà di Giurisprudenza, Università di Basilea",
      "E-mail: jonas.schuette@unibas.ch",
      "Indirizzo: Chalchrain 17, 6315 Oberägeri, Svizzera",
      "",
      "2. Finalità della ricerca",
      "La ricerca ha lo scopo di studiare scientificamente la gestione procedurale da parte dei giudici e delle autorità nel contesto dei conflitti relativi ai rapporti con i figli rilevanti per il loro benessere.",
      "L'obiettivo è quello di acquisire conoscenze empiriche su come i processi decisionali giudiziari e amministrativi e l'organizzazione dei procedimenti possano contribuire a garantire il benessere dei minori.",
      "I dati saranno trattati esclusivamente per scopi di ricerca scientifica nell'ambito della tesi di dottorato presso l'Università di Basilea e non saranno utilizzati per scopi commerciali.",
      "",
      "3. Tipo di dati raccolti",
      "Nell'ambito di questa indagine online vengono trattati i seguenti dati:",
      "- dati demografici (ad es. età, categoria professionale, anni di esperienza),",
      "- valutazioni relative alla professione e dati qualitativi (risposte a domande aperte e chiuse),",
      "- metadati tecnici (ad es. ora della partecipazione, ID della sessione).",
      "Vengono raccolti dati personali, ma non dati personali particolarmente sensibili ai sensi dell'art. 5 lett. c LPD (come ad es. informazioni sulla salute, la religione, l'orientamento politico o la sfera privata).",
      "",
      "4. Base giuridica del trattamento dei dati",
      "Il trattamento avviene sulla base di:",
      "- art. 31 cpv. 1 LPD (consenso dell'interessato) e",
      "- art. 31 cpv. 2 lett. e LPD (trattamento a fini scientifici)",
      "La partecipazione è volontaria e si basa sul consenso informato dei partecipanti.",
      "",
      "5. Memorizzazione e accesso",
      "I dati vengono memorizzati sui server di Infomaniak Network SA, Svizzera.",
      "I server si trovano in Svizzera e sono quindi soggetti alla legislazione svizzera in materia di protezione dei dati.",
      "Hanno accesso ai dati esclusivamente:",
      "- il responsabile del progetto Jonas Schütte",
      "- e, se del caso, i supervisori scientifici o i responsabili della valutazione presso l'Università di Basilea, nella misura in cui ciò sia necessario per la valutazione.",
      "Non è prevista la trasmissione a terzi o il trasferimento all'estero.",
      "",
      "6. Durata di conservazione",
      "I dati raccolti saranno conservati per il tempo necessario alla valutazione scientifica, alla stesura e all'eventuale pubblicazione della tesi di dottorato, ma al massimo per 10 anni dopo il completamento della tesi.",
      "Successivamente, i dati saranno resi anonimi o cancellati.",
      "",
      "7. Diritti dei partecipanti",
      "I partecipanti hanno il diritto:",
      "- di ottenere informazioni sui dati che li riguardano,",
      "- di correggere dati inesatti,",
      "- di cancellare i propri dati (a meno che non vi siano motivi scientifici che lo impediscano),",
      "- di limitare il trattamento,",
      "- nonché di revocare il consenso in qualsiasi momento e senza indicarne i motivi.",
      "Le richieste in tal senso possono essere indirizzate al responsabile sopra indicato.",
      "",
      "8. Volontarietà e anonimato",
      "La partecipazione a questa indagine è volontaria.",
      "È possibile interrompere il sondaggio in qualsiasi momento senza conseguenze negative.",
      "I dati raccolti saranno trattati in modo confidenziale e utilizzati esclusivamente per gli scopi di ricerca descritti.",
      "Una volta completata la raccolta dei dati, questi saranno resi anonimi, a condizione che non sia più necessaria alcuna attribuzione personale.",
      "",
      "9. Sicurezza dei dati",
      "La trasmissione dei dati avviene tramite una connessione crittografata (HTTPS).",
      "La memorizzazione e l'elaborazione avvengono su server situati in Svizzera, protetti secondo gli attuali standard di sicurezza.",
      "I diritti di accesso sono limitati al minimo necessario per la ricerca.",
    ],
    acknowledgement:
      "Sono stato informato sullo scopo, lo svolgimento e il trattamento dei dati di questa ricerca scientifica. Partecipo volontariamente e acconsento al trattamento dei miei dati personali forniti nell'ambito del sondaggio online per scopi di ricerca scientifica.",
    acceptLabel: "Accetto l'informativa sulla privacy e desidero partecipare al sondaggio.",
  },
};


